import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import CustomDropDownArray from '../../../../../utils/redux-forms-custom-fields/CustomDropDownArray';

const WhiteList = ({ 
  fields,
  meta: { error },
  isVisible,
  onRemove,
  whiteListTypeOptions
}) => {
  if (!isVisible) return null;

  return (
    <section className="WhiteListWrapper">
      <ul>
        {fields.map((whiteListItem, index) => (
          <li key={index}>
            <section className="RepeaterWrapper__fields">
              <div className="item-number">{index}</div>
              <Field
                name={`${whiteListItem}.type`}
                id={`${whiteListItem}.type`}
                placeholder="Select type"
                customLabel="Type of Whitelisting"
                component={CustomDropDownArray}
                options={whiteListTypeOptions}
              />
              <Field
                name={`${whiteListItem}.identity`}
                id={`${whiteListItem}.identity`}
                type="text"
                component={CustomInput}
                label="Username"
                placeholder="Username"
                customLabel="Username"
              />
              <button
                className="RepeaterWrapper__item-remove"
                type="button"
                onClick={() => onRemove(fields, index)}
              >
                <i className="fa fa-trash" />
              </button>
            </section>
          </li>
        ))}
      </ul>
      
      {error && <span className="RepeaterWrapper__error">{error}</span>}
      
      <button 
        className="RepeaterWrapper__add-item" 
        type="button" 
        onClick={() => fields.push({})}
      >
        Add User to Whitelist
      </button>
    </section>
  );
};

WhiteList.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired,
  whiteListTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired
};

export default React.memo(WhiteList);